<div class="pivot-wrapper">
  <div class="container" fxLayout="row">
    @if (measures().length) {
      <div class="y-axis">{{ res('Ubt-Dashboard-Chart-Benefit') }}</div>
    }
    <dx-pivot-grid
      [dataSource]="pivotGridDataSource"
      [allowSortingBySummary]="false"
      [allowFiltering]="false"
      [showBorders]="true"
      [showColumnGrandTotals]="false"
      [showRowGrandTotals]="false"
      [showColumnTotals]="false"
      [showRowTotals]="false"
      (onCellPrepared)="onCellPrepared($event)"
      (onCellClick)="styleCell($event)"
    >
      <dxo-field-chooser [enabled]="false"></dxo-field-chooser>
      <dxo-load-panel [enabled]="false"></dxo-load-panel>
    </dx-pivot-grid>
  </div>
  @if (measures().length) {
    <div class="x-axis">{{ res('Ubt-Dashboard-Chart-Speed') }}</div>
  }
</div>
